import { ButtonGroup } from '#/shared/components/ButtonGroup';
import type { PaidBreakExceptionVariant, PaidBreakRequestStatus } from '#/shared/types/PaidBreakRequest';

type PaidBreakExceptionHeaderProps = {
  title: string;
  status: PaidBreakRequestStatus;
  variant: PaidBreakExceptionVariant;
  onAccept: () => void;
  onReject: () => void;
};

export function PaidBreakExceptionHeader({
  title,
  status,
  variant,
  onAccept,
  onReject,
}: PaidBreakExceptionHeaderProps) {
  const leftButtonLabel = variant === 'summary' ? 'Accept all' : 'Accept';
  const rightButtonLabel = variant === 'summary' ? 'Reject all' : 'Reject';

  const selectedClassName = variant === 'individual' ? 'bg-[rgba(1,51,121,0.10)] text-primary-on-surface' : undefined;

  const handleChange = (value: string | undefined) => {
    if (value === 'accepted') {
      onAccept();
    } else if (value === 'rejected') {
      onReject();
    }
  };

  return (
    <div className="flex items-start gap-16 mb-8">
      <h3 className="text-base font-600 flex-1">{title}</h3>
      <div className="flex-1 flex justify-end">
        <ButtonGroup
          value={status}
          onChange={handleChange}
          options={[
            {
              label: leftButtonLabel,
              icon: 'check',
              id: 'accepted',
              selectedClassName: status === 'accepted' ? selectedClassName : undefined,
            },
            {
              label: rightButtonLabel,
              icon: 'check',
              id: 'rejected',
              selectedClassName: status === 'rejected' ? selectedClassName : undefined,
            },
          ]}
        />
      </div>
    </div>
  );
}
